import { GameObject } from './game-object';
import { Operation } from './types';

export class Coin extends GameObject {
    public operation: Operation;
    constructor() {
        super();
    }

    update(dt: number): void {}
}
